import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import BASE_URL from "../config";

const AddPayment = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const client_id = Number(queryParams.get("id"));

  const [lastPaymentDate, setLastPaymentDate] = useState("");
  const [nextDueDate, setNextDueDate] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setLastPaymentDate(today);
    setNextDueDate(today);

    const fetchClientData = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${BASE_URL}api/clients/with-payments`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          }
        });
        const client = response.data.find((c) => c.id === client_id);
        if (client) {
          setPaymentType(client.payment_type || "");
          calculateNextDueDate(client.payment_type, today);
        }
      } catch (error) {
        console.error("Error fetching client data:", error);
      }
    };

    fetchClientData();
  }, [client_id]);

  const calculateNextDueDate = (type, date) => {
    if (!type) return;

    const currentDate = new Date(date);
    if (type === "Biweekly") {
      currentDate.setDate(currentDate.getDate() + 15);
    } else if (type === "Monthly") {
      currentDate.setDate(currentDate.getDate() + 30);
    } else if (type === "Yearly") {
      currentDate.setFullYear(currentDate.getFullYear() + 1);
    } else {
      currentDate.setDate(currentDate.getDate()); 
    }
    setNextDueDate(currentDate.toISOString().split("T")[0]);
  };

  const handlePaymentTypeChange = (e) => {
    const newPaymentType = e.target.value;
    setPaymentType(newPaymentType);
    calculateNextDueDate(newPaymentType, lastPaymentDate);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem("token");
    
      const today = new Date();
      const dueDate = new Date(nextDueDate);
    
      // Compare dates and set status
      const status = dueDate >= today ? "Pending" : "Paid";
    
      const response = await axios.post(`${BASE_URL}api/payment/create`, {
        client_id,
        last_payment_date: lastPaymentDate,
        next_due_date: nextDueDate,
        status, // Include the computed status
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.message === "Payment created successfully") {
        const token = localStorage.getItem("token");
        await axios.put(`${BASE_URL}api/clients/update/${client_id}`, {
          payment_type: paymentType,
        }, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          }
        });

        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Payment added successfully!",
          confirmButtonColor: "#3085d6",
        }).then(() => navigate(`/client-payments?id=${client_id}`)
      ); // Navigates back to the previous page
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to add payment.",
        confirmButtonColor: "#d33",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <h2>Add Payment</h2>
      <form onSubmit={handleSubmit}>
      <div className="mb-3">
          <label className="form-label">Payment Type</label>
          <select
            className="form-control w-50"
            value={paymentType}
            onChange={handlePaymentTypeChange}
            required
          >
            <option value="">Select Payment Type</option>
            <option value="Biweekly">Biweekly</option>
            <option value="Monthly">Monthly</option>
            <option value="Yearly">Yearly</option>
            <option value="Onetime">One-Time</option>
          </select>
        </div>
        <div className="mb-3">
          <label className="form-label">Last Payment Date</label>
          <input
            type="date"
            className="form-control w-50"
            value={lastPaymentDate}
            onChange={(e) => setLastPaymentDate(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Next Due Date</label>
          <input
            type="date"
            className="form-control w-50"
            value={nextDueDate}
            onChange={(e) => setNextDueDate(e.target.value)}
            required
          />
        </div>
       
        <button type="submit" className="btn btn-primary me-2" disabled={loading}>
          {loading ? "Adding..." : "Add Payment"}
        </button>
        <button type="button" className="btn btn-secondary" onClick={() => {
  const client_id = Number(queryParams.get("id"));  
  navigate(`/client-payments?id=${client_id}`);
}}>
          Cancel
        </button>
      </form>
    </div>
  );
};

export default AddPayment;
